export interface ApiErrorPayload {
  code?: string;
  message?: string;
  error?: {
    code?: string;
    message?: string;
  };
}

export class ApiRequestError extends Error {
  public readonly status: number;
  public readonly code: string;

  public constructor(status: number, code: string, message: string) {
    super(message);
    this.name = "ApiRequestError";
    this.status = status;
    this.code = code;
  }
}

export async function apiRequest<T>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  const response = await fetch(path, {
    ...init,
    credentials: "include",
    headers: {
      ...(init?.body ? { "content-type": "application/json" } : {}),
      ...init?.headers,
    },
  });
  if (!response.ok) {
    const payload = (await response
      .json()
      .catch(() => ({}))) as ApiErrorPayload;
    throw new ApiRequestError(
      response.status,
      payload.error?.code ?? payload.code ?? "REQUEST_FAILED",
      payload.error?.message ??
        payload.message ??
        "请求失败，请稍后再试。",
    );
  }
  if (response.status === 204) {
    return undefined as T;
  }
  return (await response.json()) as T;
}

export async function signInWithUsername(
  username: string,
  password: string,
): Promise<{ twoFactorRequired: boolean }> {
  const result = await apiRequest<{
    twoFactorRedirect?: boolean;
    twoFactorMethods?: string[];
  }>("/api/auth/sign-in/username", {
    method: "POST",
    body: JSON.stringify({ username, password, rememberMe: true }),
  });
  return {
    twoFactorRequired: result.twoFactorRedirect === true,
  };
}

export async function signOut(): Promise<void> {
  await apiRequest("/api/auth/sign-out", {
    method: "POST",
    body: JSON.stringify({}),
  });
}
